import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'
import { NotFoundError } from 'utils/customError'
import WrappedPanduanPerilakuKerja from 'app/KinerjaPSPegawaiPage/pages/Pelaksanaan/PanduanPerilakuKerja'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabledPs = toggle?.['kinerja-ps-enabled'] || false
    const enabledAsPegawai = toggle?.['kinerja-ps-pegawai-enabled'] || false
    const enabledPsPelaksanaanSebagaiPegawai =
      toggle?.['kinerja-ps-pegawai-pelaksanaan-enabled'] || false

    if (!enabledPs || !enabledAsPegawai || !enabledPsPelaksanaanSebagaiPegawai)
      throw new NotFoundError(context.asPath, new Error('Not found'))
  },
})

const Page = (props: PageProps) => (
  <PageGuardPSPegawai>
    <WrappedPanduanPerilakuKerja {...props} />
  </PageGuardPSPegawai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengawas Sekolah Sebagai Pegawai',
}

export default Page
